
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job-search-by-client",
      function () {
        return require("private-next-pages/job-search-by-client/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/job-search-by-client"])
      });
    }
  